import React, { useEffect } from "react";
import { useArrayContext } from "../../../state/ArrayContext";
import { useSiteContext } from "../../../state/SiteContext";

/***
 * Array source that returns all languages defined for the site.
 */
export const LanguageDefinitions = React.memo(function LanguageDefinitions(): React.ReactElement {
    const { setArray } = useArrayContext();
    const { siteState } = useSiteContext();

    useEffect(() => {
        if (siteState.site?.languages) {
            setArray(siteState.site.languages.map(lang => ({ value: lang.code, props: { info: { label: [lang.label] } } })));
        }
        else {
            setArray([]);
        }
    }, [siteState, setArray]);

    return <></>;
});